<template>
  <MessagePanes />
</template>
<script>
// @ is an alias to /src
import MessagePanes from "@/components/MessagePanes.vue";

export default {
  name: "Messages",
  components: {
    MessagePanes,
  },
};
</script>